module.exports = "/img/_/_/_/assets/images/avatar/full_right/female//drow.jpg?2f996ced6161d31e1eef2a2471c9f2b4";